import type {
  Busbar,
  EnergyConsumer,
  ExternalNetworkInjection,
  PowerTransformer,
  ConnectivityNode,
  FunctionalGridElement,
  FunctionalGridElementTypes
} from './FunctionalGrid';

export class Vertice {
  static fromBusbar(busbar: Busbar): VerticeType {
    return { objectId: busbar.objectId, type: 'Busbar' };
  }

  static fromEnergyConsumer(energyConsumer: EnergyConsumer): VerticeType {
    return { objectId: energyConsumer.objectId, type: 'EnergyConsumer' };
  }

  static fromExternalNetworkInjection(
    externalNetworkInjection: ExternalNetworkInjection
  ): VerticeType {
    return {
      objectId: externalNetworkInjection.objectId,
      type: 'ExternalNetworkInjection'
    };
  }

  static fromPowerTransformer(powerTransformer: PowerTransformer): VerticeType {
    return { objectId: powerTransformer.objectId, type: 'PowerTransformer' };
  }

  static fromConnectivityNode(connectivityNode: ConnectivityNode): VerticeType {
    return { objectId: connectivityNode.objectId, type: 'ConnectivityNode' };
  }
}

export type VerticeType = FunctionalGridElement & {
  type: FunctionalGridElementTypes;
};
